import React from 'react';

import { appWithTranslation } from 'next-i18next';
import { StockXGoldResponsive } from '@stockx/ui';

import { AppLayout } from '@app/shell';
import IsomorphicProviders from '@app/shell/Providers/IsomorphicProviders';
import { withSavedPageProps } from '@app/shell/hocs/withSavedPageProps';
import type { IronAppProps } from '@app/shell/types/app';

import GlobalDynamicHead from '@app/document/_app/Head';
import GlobalBodyScripts from '@app/document/_app/Body';

import { isServer } from '@app/utils';
import { initDataDog } from '@app/rum';
import { ErrorBoundary, PageLoadingIndicator } from '@app/ui';
import ErrorNotFound from '@brochure/pages/ErrorNotFound/components/ErrorNotFoundView';

export { reportWebVitals } from '@app/shell/utils';

if (!isServer) {
  initDataDog();
}

const MyApp = ({ Component, pageProps }: IronAppProps) => {
  if (Component?.skipLayout) {
    return <Component {...pageProps} />;
  }

  const { req } = pageProps;

  return (
    <>
      <GlobalDynamicHead />
      <PageLoadingIndicator />

      <StockXGoldResponsive req={req || { headers: {} }}>
        <IsomorphicProviders req={req}>
          <AppLayout>
            <ErrorBoundary errorComponent={<ErrorNotFound />}>
              <Component {...pageProps} />
            </ErrorBoundary>
          </AppLayout>
        </IsomorphicProviders>
      </StockXGoldResponsive>

      <GlobalBodyScripts req={req} />
    </>
  );
};

/*
  It is not expected for the psuedo request/i18n translation props to change from page->page transitions.
  So we can save them as to not cause rerenders but more importantly we can skip getServerSideProp (gssp)
  calls by having these saved, we wont be dependant on them being fed from (gssp) calls reducing overall bandwidth.
  Translations need to be saved before appWithTranslations so theyre available to that function
*/
export default withSavedPageProps(appWithTranslation(MyApp));
